export function addLeadingZero(number) {
    if (number < 10 && number > 0) {
      return '0' + number;
    } else {
      return number
    }
  }